import Heading from 'components/Heading'
import React from 'react'

import vesselDraftEditButton from './Images/vessel-draft-edit-button.png'
import vesselDraftWaterDensityEditForm from './Images/vessel-draft-water-density-edit-form.png'

const VesselDraftWaterDensity = () => (
  <div>
    <Heading isDark level={2}>
      Vessel Draft &amp; Water Density Upload via Web Dashboard
    </Heading>

    <Heading isDark level={3}>
      Overview
    </Heading>
    <p>
      This page explains the step-by-step process for updating vessel draft and
      water density details through the web dashboard.
    </p>
    <p>
      <strong>Important note:</strong> Vessel draft and water density can still
      be updated from a mobile device.
    </p>

    <Heading isDark level={3}>
      Accessing the Vessel Draft Component
    </Heading>
    <p>
      Under the Ship Overview page, Arrival/Departure Vessel Draft details can
      be updated using the Edi option.
    </p>
    <img alt="Ship Overview page showing Arrival and Departure vessel drafts with Edit buttons" src={vesselDraftEditButton} />

    <Heading isDark level={3}>
      Updating Draft &amp; Water Density
    </Heading>
    <ol>
      <li>
        Click the Edit button.
      </li>
      <li>The Arrival/Departure Vessel Draft page will open.</li>
      <li>
        Update the vessel draft and water density details, then save the
        changes.
      </li>
      <li>
        The updated data will automatically be reflected on the mobile device
        while the vessel arrival/departure draft screen is open.
      </li>
      <li>
        Details can be edited multiple times until the port call is closed.
      </li>
    </ol>
    <img alt="Arrival vessel drafts edit form showing visual inspection, calculated fields, and water density input" src={vesselDraftWaterDensityEditForm} />
  </div>
)

export default VesselDraftWaterDensity
